"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdjustmentParser = void 0;
var _adjustmentSchema = require("./adjustmentSchema");
class AdjustmentParser {
  parse(raw) {
    const result = _adjustmentSchema.adjustmentSchema.safeParse(raw);
    if (result.success) {
      return {
        data: result.data
      };
    }
    const errors = result.error.errors.map(err => err.message);
    return {
      errors
    };
  }
}
exports.AdjustmentParser = AdjustmentParser;